@if(displayMode === 'card'){
<div class="login-cards">
  @for(row of loginData; track row.userRoleId) {
  <div class="login-card">
    <div class="login-card-header">
      <span class="login-card-username">{{row.userName}}</span>
      @if(isSectionEditable && row.actions?.delete){
      <ppl-button class="login-card-delete" [ariaLabel]="'Delete login for ' + row.userName" label="Delete"
        icon="fa fa-trash" [customClass]="'ghost-button'" [iconPosition]="'left'"
        (click)="action({action: 'delete', data: row})"></ppl-button>
      }
    </div>
    <div class="login-card-body">
      @for(col of cardDetailCols; track col.field){
      <div class="login-card-field">
        <span class="login-card-label">{{col.header}}:</span>
        <span class="login-card-value">{{row[col.field]}}</span>
      </div>
      }
    </div>
  </div>
  }
  @if(!loginData?.length){
  <div class="login-cards-empty">No login accounts found.</div>
  }
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="loginData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true">
</ppl-list-table>
}

<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
      <p>Are you sure you want to proceed ?</p>
  </ng-template>
</div>
